import { Component, input } from '@angular/core'

@Component({
  selector: 'mcp-input-container',
  templateUrl: './input-container.html',
  styleUrls: ['./input-container.scss'],
})
export class InputContainer {
  readonly label = input<string>()
  readonly hasError = input<boolean>(undefined)
}
